export default __webpack_public_path__ + "static/media/bell-icon.67cef325.svg";